import { useTranslation } from 'react-i18next';

import { IconButton, Tooltip } from '@treezor/design-system';

import { useAppDispatch } from '@/hooks/redux-helpers';

import { getBulkCardCreationReport } from '@/store/actions/bulkCardCreations.actions';

import { IBulkCard, IBulkCardCreationStatus } from '@/features/cards/store/models/bulk-card.model';

interface IActionsColumnProps {
  bulkCardCreation: IBulkCard;
}

export const DownloadReportAction = (props: IActionsColumnProps) => {
  const { bulkCardCreation } = props;
  const dispatch = useAppDispatch();
  const { t } = useTranslation();

  const status = bulkCardCreation.status;
  const orderId = bulkCardCreation.orderId || undefined;
  const isButtonDisabled: boolean =
    status !== undefined && (status === IBulkCardCreationStatus.RUNNING || status === IBulkCardCreationStatus.PENDING);

  const getBulkReport = (orderId: string) => {
    if (!isButtonDisabled) dispatch(getBulkCardCreationReport(orderId));
  };

  return (
    <Tooltip
      messageContent={
        status === IBulkCardCreationStatus.COMPLETE_WITH_ERROR || status === IBulkCardCreationStatus.COMPLETE
          ? (t('pages.administration.bulkCards.detailDialog.downloadReport.creationDetail') as string)
          : (t('pages.administration.bulkCards.detailDialog.downloadReport.notAvailable') as string)
      }
      placement="top"
      contentClassName="w-[200px]"
    >
      <IconButton
        icon="download"
        onClick={() => orderId && getBulkReport(orderId)}
        variant="tertiary"
        data-testid={`${bulkCardCreation.orderId}-report`}
        disabled={isButtonDisabled}
      />
    </Tooltip>
  );
};

export default DownloadReportAction;
